import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumbersOnlyDirective } from './numbers-only.directive';
import { DoubleDecimalNumbersOnlyDirective } from './decimal-numbers-only.directive';
import { DateInputDirective } from './date.directive';
import { FormatoPesoDirective } from './formato-peso.directive';
import { FormatoDniDirective } from './formato-dni.directive';
import { FormatoAlturaDirective } from './formato-altura.directive';

@NgModule({
  declarations: [NumbersOnlyDirective, DoubleDecimalNumbersOnlyDirective, DateInputDirective, FormatoPesoDirective, FormatoDniDirective, FormatoAlturaDirective],
  imports: [CommonModule],
  exports: [NumbersOnlyDirective, DoubleDecimalNumbersOnlyDirective, DateInputDirective, FormatoPesoDirective, FormatoDniDirective, FormatoAlturaDirective]
})
export class DirectivesModule { }
